export default __webpack_public_path__ + "static/media/impact.f83d20cb.mp4";